import React, { useContext } from 'react';
import * as yup from 'yup';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { ApiContext } from '@api/api';
import useForm from '@hooks/useForm/useForm';
import RingilSidebar from '@components/ringil3/Sidebar/RingilSidebar.tsx';
import RingilTextArea from '@components/framework/input/RingilTextArea.tsx';
import { Field } from '@components/framework/formfield/Field.tsx';
import { findValidationMessage } from '@utils/validation.tsx';

export interface SendTestInvoiceDataSidebarProps {
  attachmentId: string,
  parentEntityId: string,
  s3Path: string,
  visible: boolean,
  onHide: () => void;
}

interface FormData {
  json: string;
}

const SendTestInvoiceDataSidebar: React.FC<SendTestInvoiceDataSidebarProps> = ({
                                                                                 attachmentId,
                                                                                 parentEntityId,
                                                                                 s3Path,
                                                                                 visible,
                                                                                 onHide,
                                                                               }) => {
  const { tr } = useTranslationLgs();
  const { submitInvoiceValidationResponse } = useContext(ApiContext);

  const form = useForm<FormData>(
    yup.object().shape({
      json: yup.string()
        .required()
        .test('notValidJson', 'Neplatný JSON', value => {
          try {
            JSON.parse(value ?? '');
            return true;
          } catch {
            return false;
          }
        }),
    }),
    {
      json: '',
    },
    data => save(data),
    false,
    false,
  );

  const save = (data: FormData) => {
    try {
      const parsed = JSON.parse(data.json);
      parsed.original_request.attachment_id = attachmentId;
      parsed.original_request.parent_entity_id = parentEntityId;
      parsed.original_request.s3_path = s3Path;
      parsed.original_request.request_id = crypto.randomUUID();
      submitInvoiceValidationResponse(parsed, () => {
        onHide();
      });
    } catch (e) {
      console.error('Neplatný JSON:', e);
    }
  };

  return (
    <RingilSidebar
      visible={visible}
      heading={tr('SendTestInvoiceDataSidebar.title', 'Send test data')}
      onContinue={form.validateAndSend}
      onBack={onHide}
      showSaveButton={true}
      continueLabel={tr('SendTestInvoiceDataSidebar.save', 'Save')}
      disableSaveButton={false}
    >
      <Field
        errorMessage={findValidationMessage(form.validationErrors, form.names.json, tr)}
        >
      <RingilTextArea rows={20} value={form.values.json} onChange={v => form.setFieldValue(form.names.json, v)} />
      </Field>
    </RingilSidebar>
  );
};

export default SendTestInvoiceDataSidebar;
